// extracted by mini-css-extract-plugin
export var askAiIcon = "_na-9";
export var container = "_na-0";
export var groupSeparator = "_na-a";
export var highlight = "_na-4";
export var resultIcon = "_na-5";
export var resultItem = "_na-7";
export var resultSubtitle = "_na-3";
export var resultTitle = "_na-2";
export var resultsList = "_na-1";
export var searchGroup = "_na-6";
export var selected = "_na-8";